<!-- will handle the screen for the listing of methods -->
<ng-container *ngIf="(methods$ | async)?.length != 0 && !(enrollType$ | async)">
  <h1>{{ "SUGGESTED_VERIFICATION_METHOD.TITLE" | translate }}</h1>
  <p>{{ "SUGGESTED_VERIFICATION_METHOD.DESCRIPTION" | translate }}</p>

  <ul
    fxLayout="column"
    fxLayout.xs="column"
    fxLayoutGap="0.5rem"
    class="mfa-list"
  >
    <li *ngFor="let item of methods$ | async">
      <div
        class="mfa-list-item"
        (click)="_enrollMethod(item?.name?.toLowerCase() || '')"
      >
        <div
          fxLayoutAlign="center center"
          fxFlex="20"
          fxFlex.xs="40"
          class="icon"
        >
          <span
            class="mfa-icon mfa-icon-list"
            [ngClass]="'cidaas-icon-' + item?.name?.toLowerCase()"
          ></span>
        </div>
        <div class="mfa-desc" fxFlex="80" fxFlex.xs="60">
          <h3 class="mfa-title">
            <span>
              {{ "MFA_REQUIRED." + item?.name | translate }}
              {{ item?.deonticity == "MANDATORY" ? "*" : "" }}
            </span>
            <span
              class="duration"
              *ngIf="
                item?.deonticity == 'MANDATORY' &&
                (preloginMetadata$ | async | getProperty : 'skipUntil')
              "
            >
              {{
                "SUGGESTED_VERIFICATION_METHOD.DUE_ON"
                  | translate
                    : {
                        date:
                          preloginMetadata$
                          | async
                          | getProperty : "skipUntil"
                          | date : "dd",
                        month:
                          "MONTHS." +
                            (preloginMetadata$
                              | async
                              | getProperty : "skipUntil"
                              | date : "M") | translate
                      }
              }}
            </span>
          </h3>
          <p fxHide.xs>
            {{ "MFA_REQUIRED." + item?.name + "_DESC" | translate }}
          </p>
        </div>
      </div>
    </li>
  </ul>
  <div class="error-block" *ngIf="errorState$ | async">
    <p class="mat-error">{{ ((errorState$ | async)?.message || "") | translate : {tr_fallback: ((errorState$ | async)?.default_message || "ERROR_OCCURRED") | translate} }}</p>
  </div>
</ng-container>

<ng-container *ngIf="((methods$ | async)?.length || 0) <= 0 && !(enrollType$ | async)">
<div class="error-block" *ngIf="errorState$ | async">
  <p class="mat-error">{{ ((errorState$ | async)?.message || "") | translate : {tr_fallback: ((errorState$ | async)?.default_message || "ERROR_OCCURRED") | translate} }}</p>
</div>
</ng-container>

<!-- will handle the screen for all the methods are enrolled  -->
<ng-container
  *ngIf="
    ((enrollState$ | async)?.length || 0) > 0 && (methods$ | async)?.length == 0
  "
>
  <div>
    <ng-container *ngTemplateOutlet="NoSuggetedMethods"></ng-container>
  </div>
</ng-container>

<!-- will handle the view of buttons -->
<ng-container *ngIf="!(enrollType$ | async)">
  <div class="btn-wrapper">
    <div class="back">
      <!-- <a href="#"><label
      for="cidaasCancelBtn">{{'BACK' | translate}}</label></a> -->
    </div>
    <div class="btn-group">
      <cid-button
        *ngIf="doNotAskBtn$ | async"
        [btnOption]="donotAskProperty$ | async"
        (clickEvent)="_userAction('DONOTSHOWAGAIN')"
      ></cid-button>
      <cid-button
        class="continueBtn"
        *ngIf="skipUntilBtn$ | async"
        [btnOption]="skipUntilProperty$ | async"
        (clickEvent)="_userAction('SKIP')"
      ></cid-button>
      <cid-button
        class="continueBtn"
        *ngIf="skipBtn$ | async"
        [btnOption]="skipProperty$ | async"
        (clickEvent)="_userAction('SKIP')"
      ></cid-button>
      <cid-button
        class="continueBtn"
        *ngIf="continueBtn$ | async"
        [btnOption]="continueProperty$ | async"
        (clickEvent)="_loginPrecheck()"
      ></cid-button>
    </div>
  </div>
</ng-container>

<!-- Verification module for the enrollment gose here -->
<app-verification
  *ngIf="enrollType$ | async"
  [verificationType]="enrollType$ | async"
  (getEnrolledState)="_checkEnrollMethodStatus($event)"
  [configdata]="clientTenantData$ | async"
  [trackId]="trackId$ | async"
></app-verification>

<!-- will handle the template for no methods -->
<ng-template #NoSuggetedMethods>
  <div class="svg">
    <img src="assets/img/suggestmfa_no_methods.svg" alt="No methods" />
    <h3>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLED_ALL_METHODS" | translate }}
    </h3>
  </div>
</ng-template>
